// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2zdza","container":"styles_container__174H9","title":"styles_title__1hTNI","wrapper":"styles_wrapper__1V0HL","answer":"styles_answer__2hXV0"};